class StickyAddToCart extends HTMLElement {
  constructor() {
    super();

    this.listeners();
  }

  listeners() {
    const options = { rootMargin: "0px", threshold: 1.0 };
    const observer = new IntersectionObserver(this.toggleDisplay, options);
    const target = document.querySelector(".js-product-buttons");
    const product = document.querySelector(".product");

    observer.observe(target);

    if (product) {
      this.quantityIncrements(product);
    }
  }

  toggleDisplay(entries) {
    const stickyBar = document.querySelector('sticky-add-to-cart');

    entries.forEach(entry => {
      !entry.isIntersecting 
        ? stickyBar.classList.add('is-active')
        : stickyBar.classList.remove('is-active');
    });
  }

  quantityIncrements(product) {
    const quantities = product.querySelectorAll('.quantity');
    if (quantities) {
      quantities.forEach((quantity) => {
        const dataIncrement = quantity.dataset.increment;
        const quantityPlus = quantity.querySelector('.quantity__button--qty-plus');
        const quantityMinus = quantity.querySelector('.quantity__button--qty-minus');

        if (quantityPlus) {
          quantityPlus.addEventListener("click", (e) => {
            e.preventDefault();
            quantities.forEach(quantyElement => {
              const quantityInput = quantyElement.querySelector('.quantity__input');
              const increment = quantyElement === quantity ? parseInt(dataIncrement - 1) : parseInt(dataIncrement);
              quantityInput.value = parseInt(quantityInput.value) + increment;
            })
          });
        }

        if (quantityMinus) {
          quantityMinus.addEventListener("click", (e) => {
            e.preventDefault();
            quantities.forEach(quantyElement => {
              const quantityInput = quantyElement.querySelector('.quantity__input');
              const increment = quantyElement === quantity ? parseInt(dataIncrement - 1) : parseInt(dataIncrement);
              quantityInput.value = parseInt(quantityInput.value) - increment;
            });
          });
        }
      });
    }
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);